// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fLdP","image":"Header_image__NQTlC","name":"Header_name__1AmL-","info":"Header_info__1Gn7-","infoRow":"Header_infoRow__2rxg6"};